import SelectExamParts from "./SelectExamParts";

export default SelectExamParts;
